<template>
    <div class="float-left">
        <span
            class="icon-button"
            @click.stop="importarPlanilha()"
            title="Importar planilha de Subitens"
            ><i class="fa fa-upload fa-lg text-primary"></i>
            Importar Subitens
        </span>
        <b-modal v-model="mostrarModalImportarPlanilha">
            <div slot="modal-title">
                Importar Sub Itens -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            accept=".xlsx"
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharImportarSubItens()"
                    >Cancelar</b-button
                >
                <b-button
                    style="margin-left:4px"
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarSubItensImportados()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PreContratoServicos from './PreContratoServicos'

export default {
    props: {
        itemContrato: Object,
        desativarBotao: Boolean
    },

    data() {
        return {
            mostrarModalImportarPlanilha: false,
            operacao: 'UPLOAD',
            erros: [],
            arquivo: null
        }
    },

    methods: {
        importarPlanilha() {
            if (!this.desativarBotao) {
                this.mostrarModalImportarPlanilha = true
            }
        },

        fecharImportarSubItens() {
            this.mostrarModalImportarPlanilha = false
            this.resetSubItensImportForm()
        },

        resetSubItensImportForm() {
            this.erros = []
            this.$refs.arquivoInput.reset()
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        salvarSubItensImportados() {
            this.mostrarModalImportarPlanilha = false
            this.$store.dispatch('addRequest')
            let subItensData = {
                idContrato: this.itemContrato.idContrato,
                idItemReferencia: this.itemContrato.itemContratoId,
                arquivo: this.arquivo
            }

            PreContratoServicos.inserirSubItensArquivo(subItensData).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Itens importados com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )

                            this.$emit('subItens', response.data)
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {
        mostrarBtnImportarPlanilha() {
            return this.$temAcesso('EXPRPLAN-01')
        }
    },

    watch: {},

    validations: {
        arquivo: {
            required
        }
    }
}
</script>
